<template>
  <Checkbox :id="'license'" :name="'license'" v-model="licenseAgreed">
    Przeczytałem
    <a href="#" target="_blank" rel="noopener noreferrer">warunki umowy licencyjnej</a>
    i je akceptuję.
  </Checkbox>
</template>

<script>
import Checkbox from '@/components/Checkbox.vue';

export default {
  name: 'LicenseAgreementCheckbox',
  components: {
    Checkbox
  },
  created() {

  },
  computed: {
    licenseAgreed: {
      get() {
        return this.$store.getters.registrationLicenseAgreed;
      },
      set(value) {
        this.$store.commit('updateRegistrationLicenseAgreed', value);
      }
    }
  }
};
</script>
